import React, { InputHTMLAttributes } from "react";
import styled from "styled-components";

// For obscuring the input, we can utilize the "text-security" font.
const StyledPassword = styled.input<{ $showValue: boolean }>`
  ${({ $showValue }) => {
    if (!$showValue) {
      return `
        font-family: text-security-disc !important;
        /* Use -webkit-text-security if the browser supports it */
        -webkit-text-security: disc;
      `;
    }
  }}
`;

export type PasswordInputProps = InputHTMLAttributes<HTMLInputElement> &
  Partial<{
    usePasswordAsText: boolean;
    showValue: boolean;
  }>;

export function PasswordInput(props: PasswordInputProps) {
  const { autoComplete, showValue = false, usePasswordAsText = false, ...otherInputProps } = props;
  let type = showValue ? "text" : "password";
  if (usePasswordAsText) {
    type = "text";
  }
  return (
    <StyledPassword
      {...otherInputProps}
      $showValue={showValue}
      type={type}
      data-lpignore={autoComplete ? undefined : "true"}
      autoComplete={autoComplete}
      inputMode={otherInputProps.name === "ssnOrTIN" ? "numeric" : "text"}
    />
  );
}
